// BUG-2368: what the Till screen does when Retail Services cannot give the till access (tillData),
// and when a cashier picks a different till than the one this device is linked to.
import { countUnsentOrders } from "./tillDeviceRegistration";

// A db.tillRegistrations row keeps tillAccess as the list from tillData or as the one till picked.
export const registrationTill = (row) => {
  const access = Array.isArray(row?.tillAccess) ? row.tillAccess[0] : row?.tillAccess;
  const till = access?.cwrTill;
  if (!till) return null;
  return { name: till.till ?? null, searchKey: till.searchKey ?? null, cwrTillID: till.cwrTillID ?? null };
};

// The row tillRegistration writes asks cwrTill for till / searchKey / description only (no cwrTillID),
// so the linked till is matched on its id only when both sides have one, else on searchKey, else on name.
export const isSameTill = (a, b) => {
  if (a?.cwrTillID && b?.cwrTillID) return a.cwrTillID === b.cwrTillID;
  if (a?.searchKey && b?.searchKey) return a.searchKey === b.searchKey;
  if (a?.name && b?.name) return a.name === b.name;
  return null;
};

// The till this device registered last (rows are only ever appended).
export const currentLinkedTill = (rows) => {
  for (let i = (rows || []).length - 1; i >= 0; i -= 1) {
    const till = registrationTill(rows[i]);
    if (till?.cwrTillID || till?.name) return till;
  }
  return null;
};

// Resume after a failed tillData read: keep the linked till on screen (with a retry) only when this
// device really holds a registration for it. Otherwise there is nothing to keep and the list loads.
// Till names repeat (GPR: three "Dispatch" tills in three stores), so the search key decides.
export const shouldKeepLinkedTill = (rows, tillValue) => {
  if (!tillValue?.name || !tillValue?.search_key) return false;
  const value = { name: tillValue.name, searchKey: tillValue.search_key };
  return (rows || []).some((row) => isSameTill(registrationTill(row), value) === true);
};

// Picking a till other than the linked one while this device still has unsent bills or an open
// till session: syncOrders sends every pending bill under the CURRENT till / warehouse, and the open
// session would never be closed. Returns what is left to do, or null when the switch may go ahead.
// target: the picked till { cwrTillID, searchKey, name }. No linked till, or a pick that cannot be
// told apart from it, is not a switch.
export const readTillSwitchBlock = async (db, target) => {
  const rows = await db.tillRegistrations.toArray();
  const current = currentLinkedTill(rows);
  if (!current || isSameTill(current, target) !== false) return null;
  const unsentBills = await countUnsentOrders(db);
  const openSessions = await db.tillEvents.where("tillStatus").equals("open").count();
  if (unsentBills === 0 && openSessions === 0) return null;
  return { currentTill: current.name || current.cwrTillID, unsentBills, openSession: openSessions > 0 };
};

export const tillSwitchBlockMessage = (block) => {
  const parts = [];
  if (block.unsentBills > 0) parts.push(`${block.unsentBills} bill${block.unsentBills === 1 ? "" : "s"} not yet sent to the server`);
  if (block.openSession) parts.push("an open till session");
  return `This device still has ${parts.join(" and ")} for till ${block.currentTill}. Open ${block.currentTill}, let the bills send and close the till before opening another till.`;
};
